<template>
  <div class="container h-max w-max">
    <div id="a1" style="background-image: url(static/marketing/shutterstock_1020086572.jpg);" class="h-max w-max front-img">
        <div style="background-image: linear-gradient(to left, transparent 60%, #ffffff);height:50%;" class="w-max front-logo">
          <div class="p-t-sm p-l-md">
            <p><img src="static/keepyou.fit.svg" class="icon is-xlarge"></p>
            <p class="is-uppercase is-size-3 has-text-black lh-1 has-text-weight-bold">Fitness <br>& Diet</p>
        </div>
    </div>
        <div style="height:50%;background-color: #2c272b !important;" class="has-text-centered">
              <a class="button is-primary is-rounded is-size-4 p-l-xl p-r-xl m-b-md m-t-md  is-uppercase has-text-weight-bold" :href="link">Buy now for 20 Euros</a>
              <p class="is-size-7 p-sm" style="max-width: 400px; margin: auto;">By clicking the "BUY NOW FOR 20 EUROS" button below, I hereby agree to and accept the following terms and conditions on the keep you fit website. I further reaffirm my acceptance of the general termsand conditions governing my use of any Myriad website (including but not limited to the keep you fit website), which general terms and conditions are incorporated herein by reference. Unlimited access to KeepYouFit. Total cost €20 (10 x €2 SMS).</p>
        </div>
  </div>
  <div id="a3" class="h-max w-max is-vertical-center has-text-centered is-uppercase is-size-5" style="overflow:hidden;">
    <div class="is-fullwidth p-b-xl">
      <p class="is-size-2 has-text-weight-bold is-portrait">Sexy belly, <br> shaped bottom and legs!</p>
      <p><img src="static/lp/icon_01a.png" style="height: 5rem;"><br>Perfect for beginners and advanced users</p>
      <p><img src="static/lp/icon_02a.png" style="height: 5rem;"><br>Configure for yourself</p>
    </div>
  </div>
  <div id="a4" class="h-max w-max is-uppercase has-text-weight-bold">
    <div class="h-max w-max has-text-centered is-portrait" style="background-image: url(static/lp/food.png);background-size: 100% auto;background-position: top center;background-repeat:no-repeat;position: relative;">
      <div class="is-fullwidth" style="position: absolute;bottom: 7rem;">
        <p class="is-size-2 has-text-weight-bold">EAT CONSCIOUSLY!</p>
      </div>
    </div>
    <div class="h-max w-max is-vertical-center has-text-centered is-landscape is-uppercase has-text-weight-bold" style="background-image: url(static/lp/food.png);background-size: 100% auto;background-position: center center;background-repeat:no-repeat;">
      <div class="is-fullwidth m-b-xxl" style="background: rgba(255,255,255,0.5);">
        <p class="is-size-2 has-text-weight-bold">EAT CONSCIOUSLY!</p>
      </div>
    </div>
  </div>
  <div id="a5" class="m-b-lg h-max w-max is-vertical-center has-text-centered is-uppercase has-text-weight-bold">
    <div class="is-fullwidth p-b-xl">
      <p><img src="static/lp/icon_03a.png" style="height: 5rem;"><br>Few rules, a lot of knowledge</p>
      <p><img src="static/lp/icon_04a.png" style="height: 5rem;"><br>Simple and quick recipes</p>
    </div>
  </div>
  <div class="h-max w-max has-text-left">
    <div class="has-text-centered has-background-grey p-none m-none"><img src="static/marketing/payment_slider3.jpg" class="p-none" style="display:block;width:100%;max-width:70rem;margin: 0 auto;"></div>
    <div class="p-l-sm p-r-sm p-t-lg">Keep YOU fit is a fitness and training portal made for the end-user ́s needs. The customer can choose which category best suits his body shape. At beginning as well as at any time later the end-user has the possibility to define his next goal. On the basis of the results the system prepares the optimal training program matching the user requirements. The customer gets workouts in form of videos with specified number of repetitions. - User meet his goals at his own pace that's tailored to him - User with weekly training and nutrition plan, will increase his fitness level all at his own pace. Warmups, workouts, stretching and nutrition, the complete package - Not a rushed job! The best combination of workouts and nutrition to get into hero shape for the long-term.</div>
  </div>
  <div class="has-text-centered has-text-light fixed-bl is-fullwidth is-uppercase has-text-weight-bold">
    <div class="has-text-left is-size-6 has-text-light is-family-secondary">
      <a class="has-text-light m-r-sm m-l-sm" href="http://ie.keepyou.fit/#/terms-and-conditions">T & C</a> |
      <a class="has-text-light m-r-sm m-l-sm" href="http://ie.keepyou.fit/#/imprint">Imprint</a> |
      <a class="has-text-light m-r-sm m-l-sm" href="http://ie.keepyou.fit/#/help">Help</a>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Statisitc',
  data () {
    let link = `http://ie.keepyou.fit/mgage/lp/ie`
    const requestIdArr = document.location.toString().match(/request_id=(.*)/)
    if (requestIdArr !== null) {
      link = `http://ie.keepyou.fit/mgage/lp/ie?${ requestIdArr[0] }`
    }
    return {
      profile: this.$store.getters.getProfile,
      link
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'open') {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    updateProfile () {
      this.profile.age = parseInt(this.profile.age)
      this.profile.height = parseInt(this.profile.height)
      this.profile.weight = parseInt(this.profile.weight)
      this.$store.dispatch('updateProfile', this.profile)
    }
  }
}
</script>

<style>
.is-vertical-center {
display: flex;
align-items: center;
}
.shadow {
-webkit-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
-moz-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
}
.steps .steps-marker {
    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%);
}

.h-max {
    min-height: 100%;
    height: 100%;
}
.w-max {
    min-width: 100%;
    width: 100%;
}
.fixed-tl {
    position: fixed;
    top:0;
    left: 0;
}
.fixed-bl {
    position: fixed;
    bottom:0;
    left: 0;
}
.fixed-tr {
    position: fixed;
    top:0;
    right: 0;
}
.fixed-br {
    position: fixed;
    bottom:0;
    right: 0;
}
.lh-1 {
    line-height: 1 !important;
}
.bg-point {
    background-color: transparent;
    background-image: radial-gradient(#f99819 50%, transparent 51%, transparent 60%, #f99819 61%, #f99819 65%, transparent 66%);
}

.front-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 120%;
}
.invert-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
}
@media screen and (orientation:landscape) {
    .front-img {
        background-size: 100% auto;
    }
    .invert-img {
        background-size: auto 100%;
        background-position: top left;
    }
    .front-logo {
        display: block;
    }
    .is-portrait {
        display: none;
    }
}
@media screen and (orientation:portrait) {
    .is-landscape {
        display: none;
    }
    .front-img {
        background-size: auto 60%;
    }
    .lp-logo {
        position: absolute;
        bottom: 40%;
        margin-bottom: -7.2rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/LangKyf/IE/LP.vue